import { MULTIHOUSEHOLD_ACTION_TYPES } from '@constants/actionTypes/dashboardActionTypes';
 
export const INITIAL_STATE = null;
 
export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case (MULTIHOUSEHOLD_ACTION_TYPES.SET_ACTIVE_HOUSEHOLD):
            return action.activeHouseholdId;

        case (MULTIHOUSEHOLD_ACTION_TYPES.CLEAR_DASHBOARD_STATE):
            return INITIAL_STATE;

        default:
            return state;
    }
};